<template>
    <b-container>
        <h1><font-awesome-icon :icon="['fa-regular', 'fa-clock']" /> Reminders</h1>
        <b-card deck no-body class="overflow-hidden border-0" v-for="item in items" :key="item.id"
                    style="border-bottom: 1px solid #EEE !important">
                    <b-row no-gutters class="p-2">
                        <b-col cols="1">
                            <b-card-img src="/images/avatars/robot.png" fluid class="rounded-0 ms-2 me-5"></b-card-img>
                        </b-col>
                        <b-col cols="11">
                            <b-card-body class="py-0 pr-0 overflow-hidden" style="max-width: 800px;">
                                <b-card-text><strong>IMS Reminder Bot</strong> <span class="text-muted">{{ item.remind_at | fullDate
                                        }}</span></b-card-text>
                                <b-card-text>
                                    You asked me send this reminder: <a :href="`${item.link}`" v-html="item.message"></a>
                                </b-card-text>
                                <b-row>
                                    <b-col><b-button @click="completeReminder(item.id)">Mark Completed</b-button></b-col>
                                    <b-col md="7"><b-form-select :id="`opt_reminder_${item.id}`" v-model="snooze_selected" :options="snooze_options" @change="snoozeReminder(item.id)"></b-form-select></b-col>
                                    <b-col md="2"><b-button variant="primary" @click="deleteReminder(item.id)"><font-awesome-icon :icon="['fa-regular', 'fa-trash-can']" /></b-button></b-col>
                                </b-row>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
      </b-container>
</template>
<script>
import ReminderDataService from "@/services/ReminderDataService";

export default {
    data() {
    return {
        items: [],
        snooze_options: [
      {
        "value": "",
        "text": "Snooze"
      },
      {
        "value": "20",
        "text": "in 20 minutes"
      },
      {
        "value": "60",
        "text": "in 1 hour"
      },
      {
        "value": "180",
        "text": "in 3 hours"
      },
      {
        "value": "tomorrow",
        "text": "tomorrow at 9am"
      },
      {
        "value": "nextweek",
        "text": "next week Monday at 9am"
      }
    ],
    snooze_selected: ""

    };
  },
  created() {

    this.getList();

  },
  methods: {
    snoozeReminder(id) {
      ReminderDataService.update(id, {
        snooze: this.snooze_selected
      }).then(() => {
        this.getList();
        this.snooze_selected = ""
      })
    },
    deleteReminder(id) {
      ReminderDataService.delete(id).then(() => {
        this.getList();
        this.snooze_selected = ""
      })
    },
    completeReminder(id) {
      ReminderDataService.dismiss(id).then(() => {
        this.getList();
        this.snooze_selected = ""
      })
    },
    getList(){
        ReminderDataService.getAll().then((res) => {
      this.items = res.data;
      
    })
    }
  }
  
};
</script>